import Vue from 'vue';
import Router from 'vue-router';
import routes from './router/path';
import store from './store';

Vue.use(Router);

function routing(path, page, name, title, authRequired, roles) {
  return {
    name: page || name,
    path,
    component: async () => import(`@/pages/${page}.vue`),
    meta: {
      title: title || name,
      authRequired: authRequired || false,
      roles: roles || []
    }
  };
}

const verifyIfUserIsAuthenticated = async (to, from, next) => {
  await store.dispatch('login/initApp');

  if (store.state.login.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTE_BASE_URL,
  routes: routes.map(r => {
    const route = routing(
      r.path,
      r.page,
      r.name,
      r.title,
      r.authRequired,
      r.roles
    );
    if (r.authRequired) {
      route.beforeEnter = verifyIfUserIsAuthenticated;
    }
    return route;
  })
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('login/initApp');

  if (store.state.login.isAuthenticated && store.getters['login/accessValid'] === false && to.path !== '/login' && to.path !== '/Profile') {
    next('/Profile');
    return;
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
